(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (() => {
    const selector = '.announcement-bar a[href], [data-bd-discount]';
    const updateLink = link => {
      if (!link) return;
      const discountUrl = new URL(link.href, window.location.origin);
      if (discountUrl.origin !== window.location.origin || !/\/discount\/BIENVENUE\/?$/i.test(discountUrl.pathname)) return;
      const path = window.location.pathname + window.location.search + window.location.hash;
      if (!path.startsWith('/') || path.startsWith('//') || path.includes('\\') || new URL(path, window.location.origin).origin !== window.location.origin) return;
      discountUrl.searchParams.set('redirect', path);
      link.href = discountUrl.pathname + discountUrl.search;
    };
    const updateLinks = (root = document) => root.querySelectorAll(selector).forEach(updateLink);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => updateLinks(), { once: true });
    else updateLinks();
    ['pointerdown', 'focusin', 'click', 'auxclick'].forEach(type => {
      document.addEventListener(type, event => updateLink(event.target.closest?.(selector)), true);
    });
    document.addEventListener('shopify:section:load', event => updateLinks(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bd-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const subscribedKey = 'bd_club_subscribed_v1';
    const dismissedKey = 'bd_welcome_dismissed_v1';
    const sessionKey = 'bd_welcome_shown_v1';
    const pendingKey = 'bd_club_pending_v1';
    const read = (key, session = false) => { try { return (session ? sessionStorage : localStorage).getItem(key); } catch { return null; } };
    const write = (key, value, session = false) => { try { (session ? sessionStorage : localStorage).setItem(key, value); } catch {} };
    const start = (root = document) => {
      root.querySelectorAll('[data-bd-welcome]').forEach(dialog => {
        if (dialog.dataset.initialized === 'true' || typeof dialog.showModal !== 'function') return;
        dialog.dataset.initialized = 'true';
        const designMode = dialog.dataset.designMode === 'true';
        const confirmed = !!dialog.querySelector('[data-bd-club-success]');
        const hasError = !!dialog.querySelector('[data-bd-club-error]');
        const pending = read(pendingKey, true) === 'true';
        const knownSubscriber = dialog.dataset.knownSubscriber === 'true' || read(subscribedKey) === 'true';
        const days = Math.max(1, Number(dialog.dataset.dismissDays) || 7);
        const lastDismissed = Number(read(dismissedKey)) || 0;
        let previousFocus;
        let timer;
        let previousOverflow;
        let scrollLocked = false;
        let closed = false;
        const selectStep = (name, focus = false) => {
          dialog.querySelectorAll('[data-bd-step]').forEach(step => { step.hidden = step.dataset.bdStep !== name; });
          if (focus) {
            const target = name === 'club' ? dialog.querySelector('input[type=email]') : dialog.querySelector('.bd-welcome__title');
            target?.focus({ preventScroll: true });
          }
        };
        const restoreScroll = () => {
          if (scrollLocked) document.body.style.overflow = previousOverflow;
          scrollLocked = false;
        };
        const dismiss = () => {
          closed = true;
          clearTimeout(timer);
          if (!designMode) write(dismissedKey, String(Date.now()));
          dialog.close();
        };
        const open = () => {
          if (!dialog.isConnected || closed || dialog.open) return;
          previousFocus = document.activeElement;
          previousOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
          scrollLocked = true;
          dialog.querySelector('.bd-welcome__title')?.focus({ preventScroll: true });
          if (!designMode) write(sessionKey, 'true', true);
        };
        const isBusy = () => {
          if (document.visibilityState !== 'visible') return true;
          if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return true;
          return Array.from(document.querySelectorAll('dialog[open], [role="dialog"], [aria-modal="true"]')).some(other => {
            if (other === dialog || other.closest('dialog:not([open]), [hidden], [aria-hidden="true"]')) return false;
            const style = getComputedStyle(other);
            const box = other.getBoundingClientRect();
            return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 && box.width > 0 && box.height > 0 && box.right > 0 && box.left < innerWidth && box.bottom > 0 && box.top < innerHeight;
          });
        };
        const tryOpen = () => {
          if (closed || !dialog.isConnected || read(subscribedKey) === 'true' || read(sessionKey, true) === 'true') return;
          if (isBusy()) { timer = setTimeout(tryOpen, 5000); return; }
          open();
        };
        dialog.querySelectorAll('[data-bd-close]').forEach(button => button.addEventListener('click', dismiss));
        dialog.querySelector('[data-bd-show-club]')?.addEventListener('click', () => selectStep('club', true));
        dialog.querySelector('[data-bd-back]')?.addEventListener('click', () => selectStep('choice', true));
        dialog.querySelector('form')?.addEventListener('submit', () => write(pendingKey, 'true', true));
        dialog.querySelectorAll('[data-bd-pro], [data-bd-discount]').forEach(link => link.addEventListener('click', dismiss));
        dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
        dialog.addEventListener('close', () => {
          restoreScroll();
          if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
        });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dismiss();
        });
        document.addEventListener('shopify:section:unload', event => {
          if (!event.target.contains(dialog)) return;
          clearTimeout(timer);
          closed = true;
          if (dialog.open) dialog.close();
          restoreScroll();
        });
        if (!designMode && (dialog.dataset.knownSubscriber === 'true' || confirmed)) write(subscribedKey, 'true');
        if (confirmed) write(pendingKey, 'false', true);
        if (confirmed && pending && !knownSubscriber) { selectStep('success'); open(); return; }
        if (hasError && pending) { selectStep('club'); open(); dialog.querySelector('input[type=email]')?.focus(); return; }
        if (designMode) { open(); return; }
        if (knownSubscriber || dialog.dataset.hasCart === 'true' || read(sessionKey, true) === 'true') return;
        if (lastDismissed && Date.now() - lastDismissed < days * 86400000) return;
        timer = setTimeout(tryOpen, Math.max(20, Number(dialog.dataset.delay) || 25) * 1000);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), { once: true });
    else start();
    document.addEventListener('shopify:section:load', event => start(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
	this.header = document.querySelector('.shopify-section-header');
	this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
	this.headerBounds = {};
	this.currentScrollTop = 0;
	this.preventReveal = false;

	if (this.headerIsAlwaysSticky) {
	this.header.classList.add('shopify-section-header-sticky');
	this.header.classList.add('always-fixed');
	};

	this.onScrollHandler = this.onScroll.bind(this);
	this.hideHeaderOnScrollUp = () => this.preventReveal = true;
	this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.addEventListener('scroll', this.onScrollHandler, false);

	this.createObserver();
	}

	disconnectedCallback() {
	this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
	let observer = new IntersectionObserver((entries, observer) => {
	this.headerBounds = entries[0].intersectionRect;
	observer.disconnect();
	});

	observer.observe(this.header);
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (this.preventHide) return;
	requestAnimationFrame(this.hide.bind(this));
	} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	// The scroll offset value when opening a modal window 14px.
	// This prevents the header menu from appearing when modal windows are opened.
	if (!this.preventReveal && this.currentScrollTop - scrollTop != 14) {
	requestAnimationFrame(this.reveal.bind(this));
	}else {
	window.clearTimeout(this.isScrolling);

	this.isScrolling = setTimeout(() => {
	this.preventReveal = false;
	}, 66);

	requestAnimationFrame(this.hide.bind(this));
	}
	} else if (scrollTop <= this.headerBounds.top) {
	requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
	this.closeMenuDisclosure();
	}

	reveal() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

	const syncAlmaPaymentPlans = () => {
		document.querySelectorAll('.alma_widget_block').forEach((block) => {
			const widget = block.querySelector('#alma-widget-payment-plans-main-container');
			const installmentOptions = Array.from(block.querySelectorAll('[role="option"]')).filter((option) =>
				/^\d+\s*[x×]$/i.test(option.textContent.trim())
			);
			const hasEligibleInstallment = installmentOptions.some(
				(option) => option.getAttribute('aria-disabled') !== 'true' && !option.disabled
			);
			block.hidden = !widget || !hasEligibleInstallment;
		});
	};

	if (!document.documentElement.hasAttribute('data-alma-eligibility-guard')) {
		document.documentElement.setAttribute('data-alma-eligibility-guard', '');
		const almaEligibilityObserver = new MutationObserver(syncAlmaPaymentPlans);
		almaEligibilityObserver.observe(document.documentElement, {
			subtree: true,
			childList: true,
			attributes: true,
			attributeFilter: ['aria-disabled'],
		});
		document.addEventListener('DOMContentLoaded', syncAlmaPaymentPlans, { once: true });
		syncAlmaPaymentPlans();
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}

		hide() {
			super.hide();
			window.pauseAllMedia();
		}

		show(opener) {
			super.show(opener);
			this.showActiveMedia();
		}

		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
			}
			
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
	

  } catch(e) { console.error(e); }
})();
})();
